module.exports = __webpack_public_path__ + "static/media/mozarella.b37905e1.png";